/**
 * Counts fields the operator changed vs the last AI parse payload stored on the quote.
 * A field counts if: current value is non-empty (trim) AND differs from the AI-suggested value.
 * Used only when quote.aiParsedPayload?.data exists.
 */

function nonEmpty(val) {
  if (val == null) return false;
  const s = typeof val === "string" ? val : val?.toString?.() ?? "";
  return String(s).trim() !== "";
}

function normStr(v) {
  if (v == null) return "";
  return String(v).trim();
}

function packagesFingerprint(pkgs) {
  if (!Array.isArray(pkgs)) return "";
  return JSON.stringify(
    pkgs.map((p) => ({
      description: normStr(p?.description),
      quantity: p?.quantity,
      weight: p?.weight,
      length: p?.length,
      width: p?.width,
      height: p?.height,
      stackable: p?.stackable,
      hazardous: p?.hazardous,
    }))
  );
}

/**
 * @param {object} quote – loaded quote with containerDetails, customerDetails, aiParsedPayload.data
 * @returns {number}
 */
export function countOperatorEditsSinceAiParse(quote) {
  const ai = quote?.aiParsedPayload?.data;
  if (!ai || typeof ai !== "object") return 0;

  const cd = quote?.containerDetails || {};
  const cust = quote?.customerDetails || {};
  const rc = cd.receiverContactDetails || {};

  let n = 0;

  const check = (current, aiVal) => {
    if (!nonEmpty(current)) return;
    if (normStr(current) !== normStr(aiVal)) n += 1;
  };

  check(cd.origin, ai.origin);
  check(cd.destination, ai.destination);
  check(cd.requirements, ai.requirements);

  check(cust.name, ai.customerName);
  check(cust.email, ai.customerEmail);
  check(cust.phone, ai.customerPhone);

  check(rc.name, ai.customerName);
  check(rc.email, ai.customerEmail);
  check(rc.phone, ai.customerPhone);

  if (Array.isArray(ai.packages) && ai.packages.length > 0) {
    const curFp = packagesFingerprint(cd.packages || []);
    const aiFp = packagesFingerprint(ai.packages);
    if (nonEmpty(curFp) && curFp !== aiFp) n += 1;
  }

  return n;
}
